import React from 'react';
import PropTypes from 'prop-types';
import './DayOfMonthSelector.css';

function DayOfMonthSelector({ value, onChange, disabled }) {
  const handleInputChange = (e) => {
    const day = e.target.value;
    if (day === '') {
      onChange('');
      return;
    }

    let numDay = parseInt(day, 10);
    if (Number.isNaN(numDay)) return;

    // Only clamp max immediately (nothing valid > 28)
    // Min is clamped on blur to allow typing 10-19
    if (numDay > 28) numDay = 28;

    onChange(numDay);
  };

  const handleBlur = () => {
    // Clamp to minimum on blur (allows typing 10-19 without immediate override)
    if (value !== '' && value < 2) {
      onChange(2);
    }
  };

  return (
    <div className="day-picker-container">
      <div>
        <input
          type="number"
          className="qmb-input"
          placeholder="Day"
          value={value || ''}
          onChange={handleInputChange}
          onBlur={handleBlur}
          min="2"
          max="28"
          disabled={disabled}
          style={{ width: '70px', marginBottom: '4px' }}
        />
        <div className="help-text" style={{ fontSize: '12px', color: '#6c757d' }}>
          Enter a number between 2–28
        </div>
      </div>
    </div>
  );
}

DayOfMonthSelector.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

DayOfMonthSelector.defaultProps = {
  value: '',
  disabled: false
};

export default DayOfMonthSelector;
